// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import PartSelector from './PartSelector'
import type {
  EditorFooter_meeting as Meeting,
} from './__generated__/EditorFooter_meeting.graphql'
import type {
  EditorFooter_proposal as Proposal,
} from './__generated__/EditorFooter_proposal.graphql'

type Props = {
  disabled: boolean,
  meeting: ?Meeting,
  proposal: Proposal,
}

function EditorFooter(props: Props): Node {
  return <PartSelector {...props} />
}

EditorFooter.defaultProps = {
  disabled: false,
}

export default (createFragmentContainer(EditorFooter, {
  proposal: graphql`
    fragment EditorFooter_proposal on Proposal {
      id
      status
      
      ...PartSelector_proposal
    }
  `,
  meeting: graphql`
    fragment EditorFooter_meeting on Meeting {
      ...PartSelector_meeting
    }
  `,
}): RelayFragmentContainer<typeof(EditorFooter)>)
